import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ServiceNoteIssueHdrContainerModel } from '../../../../../../models/aggregates/erp/rma';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { Observable } from 'rxjs';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';
import { Pagination, PagingResponseModel } from './../../shared';
import { SvcIssueProcessStatusDto } from '../../../data-transfer-objects/svc-issue-process-status-dto.model'
import { HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ServiceNoteIssueHdrService extends BaseApiPublicLoginTemplateService<ServiceNoteIssueHdrContainerModel, ServiceNoteIssueHdrContainerModel, ServiceNoteIssueHdrContainerModel> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-hdrs/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-hdrs/backoffice-ep';
    this.httpClient = http;
    this.endpoint_path_public_url =  Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-hdrs/' + BaseApiTemplateService.PUBLIC_EP;
  }

  public getByCriteriaPublicEp(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public updateProcessStatus(guid: string, dto: SvcIssueProcessStatusDto, visa: ApiVisa) {
    if(visa.api_domain_url && Core2Config.TENANT_DOMAIN_URL_PREFIX) {
     this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + "svc/issue-hdrs";
    }
    const url = this.apiUrl + '/update-process-status/' + Core2Config.BACKOFFICE_EP_SUFFIX + `/${guid}`;
    return this.httpClient.put<BasicApiResponseModel<ServiceNoteIssueHdrContainerModel>> (url, dto, this.getHttpHeader(visa))
  }

  getByCriteriaPost(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<ServiceNoteIssueHdrContainerModel>> {
      let url;
      if (this.endpoint_path && visa.api_domain_url) {
        url = visa.api_domain_url + this.endpoint_path + '/query';
      }
      return this.httpClient.post<ApiResponseModel<ServiceNoteIssueHdrContainerModel>>(
        url,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }
}
